import React from 'react';

import { ClosedBookSVG, OpenedBookSVG } from '@components/svgs';
import { Tooltip } from '@components/Tooltip';

export const CategoryIcon = ({
  mergedCategories,
  defaultCategories,
  category,
  'data-testid': dataTestId
}: {
  mergedCategories: { name: string; categories: string[] }[];
  defaultCategories: string[];
  category: string;
  'data-testid'?: string;
}) => {
  const mergedCategory = mergedCategories.find(({ name }) => name === category);

  const includesDefaultCategory =
    mergedCategory && mergedCategory.categories.some((category) => defaultCategories.includes(category));

  if (defaultCategories.includes(category) || includesDefaultCategory) {
    return (
      <Tooltip maxWidth={200} content='Closed category defined by the researcher.'>
        <ClosedBookSVG className='h-4 w-4' data-testid={dataTestId} />
      </Tooltip>
    );
  }

  return (
    <Tooltip maxWidth={200} content='Open category defined by the participant.'>
      <OpenedBookSVG className='h-4 w-4' data-testid={dataTestId} />
    </Tooltip>
  );
};
